import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSlideAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M2 18V2H18V6.11111H22V22H6V18H2ZM16.5 3.5V6.11111H6V16.5H3.5V3.5H16.5ZM14.8056 10H13.3056V13.3056H10V14.8056H13.3056V18H14.8056V14.8056H18V13.3056H14.8056V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlideAdd;
